module.exports = __webpack_public_path__ + "static/media/MHRP29N0018.441df743.svg";